import * as React from "react";
import {useEffect, useState} from "react";
import {Box, Button, Drawer, IconButton, Stack} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {useTranslation} from "react-i18next";
import {Link, NavLink, useLocation} from "react-router-dom";
import logo from "../logo/logo512.png";
import {colors} from "../styling/GlobalTheme";

const pages = [
    {key: "Home", to: "/"},
    {key: "Course", to: "/course"},
    {key: "Activites", to: "/activites"},
    {key: "Champions", to: "/champions"},
    {key: "Club", to: "/club"},
    {key: "Mouchtec", to: "/mouchtec"},
];

const linkSx = {
    color: "#fff", textDecoration: "none", fontWeight: 600, fontSize: ".95rem", position: "relative", py: .5,
    "&::after": {content: '""', position: "absolute", left: 0, bottom: -2, height: 2, width: 0, bgcolor: colors.glacier, transition: ".25s"},
    "&:hover::after, &.active::after": {width: "100%"},
};

const ResponsiveAppBar = () => {
    const {t} = useTranslation();
    const {pathname} = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll, {passive: true});
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    useEffect(() => setOpen(false), [pathname]);

    const label = (k: string) => k === "Home" ? "Accueil" : k === "Activites" ? "Activités" : t(k);

    return (
        <Box component="header" sx={{
            position: "fixed", top: 0, left: 0, right: 0, zIndex: 1100, transition: ".3s",
            px: {xs: 2, md: 4}, py: scrolled ? 1 : {xs: 1.5, md: 2},
            bgcolor: scrolled ? "rgba(11,18,32,.88)" : "transparent", backdropFilter: scrolled ? "blur(12px)" : "none",
            boxShadow: scrolled ? "0 6px 20px rgba(0,0,0,.15)" : "none",
            display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
            <Link to="/" aria-label="Mouch'Paba – accueil" style={{display: "flex"}}>
                <img alt="Mouch'Paba" src={logo} style={{height: scrolled ? 42 : 52, transition: "height .3s", filter: "drop-shadow(0 2px 6px rgba(0,0,0,.4))"}}/>
            </Link>

            <Stack direction="row" spacing={3.5} alignItems="center" sx={{display: {xs: "none", md: "flex"}}}>
                {pages.map(p => (
                    <Box key={p.key} component={NavLink} to={p.to} end={p.to === "/"} sx={linkSx}>{label(p.key)}</Box>
                ))}
            </Stack>

            <IconButton onClick={() => setOpen(true)} aria-label="Menu" sx={{display: {xs: "flex", md: "none"}, color: "#fff"}}>
                <MenuIcon fontSize="large"/>
            </IconButton>
            <Drawer anchor="right" open={open} onClose={() => setOpen(false)}
                    PaperProps={{sx: {width: "100%", maxWidth: 420, bgcolor: "rgba(11,18,32,.97)", color: "#fff", p: 3}}}>
                <IconButton onClick={() => setOpen(false)} aria-label="Fermer" sx={{alignSelf: "flex-end", color: "#fff"}}><CloseIcon fontSize="large"/></IconButton>
                <Stack spacing={3} alignItems="center" sx={{mt: 6}}>
                    {pages.map(p => (
                        <Box key={p.key} component={NavLink} to={p.to} end={p.to === "/"} sx={{...linkSx, fontSize: "1.6rem"}}>{label(p.key)}</Box>
                    ))}
                </Stack>
            </Drawer>
        </Box>
    );
};
export default ResponsiveAppBar;
